import React from 'react';
import { connect } from 'react-redux';
import {
    fetchOrgUnitHierarchy
} from './../../../reduxFiles/actionTypes';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { Icon, List, Input } from 'semantic-ui-react';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const OrgUnitHierarchy = (props) => {
    const createNode = function(orgUnit) {
        return {
            id: orgUnit[0],
            name: orgUnit[1],
            parent: orgUnit[2],
            children: []
        }
    }

    const orgUnitHierarchy = props.orgUnitHierarchy;
    let root = null;
    const orgUnitsNodeHash = orgUnitHierarchy.reduce((accumulator, currentValue) => {
        let currentNode = createNode(currentValue);
        if (!root && currentNode.parent === null) {
            root = currentNode;
        }
        accumulator[currentNode.id] = currentNode;
        return accumulator;
    }, {});
    for (let prop in orgUnitsNodeHash) {
        let orgUnitNode = orgUnitsNodeHash[prop];
        if (orgUnitNode.parent !== null) {
            orgUnitsNodeHash[orgUnitNode.parent].children.push(orgUnitNode);
        }
    }
    return (
        <List selection style={{height:'100%',overflow: 'scroll'}}>
            {root &&
                <OrgUnitListItem orgUnit={root} onOrgUnitClicked={props.onOrgUnitClicked}/>
            }
        </List>
    )
}

class OrgUnitListItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddChild: false,
            isAddOrgUnitVisibile: 'hidden'
        };
    }

    setShowAddChild(value) {
        this.setState({showAddChild: value});
    }

    render() {
        return (
        // TODO emir: add active class
        <List.Item onClick={this.props.onOrgUnitClicked}
                    value={`${this.props.orgUnit.id}`}
                    style={{paddingRight : '0px', display: 'flex'}}>
            <List.Icon name='graduation' />
            <span style={{width: '100%', marginLeft: '5px'}}>
                <List.Content>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}
                            onMouseOver={() => {this.setState({isAddOrgUnitVisibile : 'visible'})}}
                            onMouseOut={() => {this.setState({isAddOrgUnitVisibile : 'hidden'})}}>
                        <div>
                            <List.Header>{this.props.orgUnit.name}</List.Header>
                        </div>
                        <div style={{display: 'flex', visibility: this.state.isAddOrgUnitVisibile}}>
                            <Icon circular name='chevron down' onClick={() => {this.setShowAddChild(true)}}/>
                                {this.props.orgUnit.parent &&
                            <Icon circular name='chevron right' onClick={this.props.addSiblingOrgUnitToCreateForm}/> }
                        </div>
                    </div>
                    {this.state.showAddChild &&
                        <List.List>
                            <OrgUnitListItemToAddContainer
                                parentOrgUnit={this.props.orgUnit}
                                cancel={() => {this.setShowAddChild(false)}}/>
                        </List.List>
                    }
                    {this.props.orgUnit.children.map(orgUnit =>
                        <List.List key={orgUnit.id}>
                            <OrgUnitListItem
                                orgUnit={orgUnit}
                                onOrgUnitClicked={this.props.onOrgUnitClicked}
                                addSiblingOrgUnitToCreateForm={() => {this.setShowAddChild(true)}}/>
                        </List.List>
                    )}
                </List.Content>
            </span>
        </List.Item>)
    }
}


class OrgUnitListItemToAddPresentation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            orgUnit: {
                name: '',
                parents: [{
                    'id': this.props.parentOrgUnit.id
                }]
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.createOrgUnit = this.createOrgUnit.bind(this);
    }

    handleChange = (e, { name, value }) => {
        this.setState((prevState) => ({
            orgUnit: {
                name: value,
                parents: prevState.orgUnit.parents
            }
        }));
    }

    createOrgUnit() {
        axios.post(`/organizational-units`, this.state.orgUnit)
        .then(response => {
            this.props.dispatch(fetchOrgUnitHierarchy());
            this.props.cancel();
        }).catch(error => {
            toast(<FormattedMessage id='orgUnitDetailed.errors.creatingOrgUnit'/>);
            this.props.cancel();
        });
    }

    render() {
        return (
        <List.Item>
            <List.Icon name='graduation' />
            <List.Content>
                <List.Header style={{marginBottom: '5px'}}>
                    <Input value={this.state.orgUnit.name} onChange={this.handleChange} />
                </List.Header>
                <Icon circular name='check' onClick={this.createOrgUnit}/>
                <Icon circular name='cancel' onClick={() => {this.props.cancel()}}/>
            </List.Content>
        </List.Item>)
    }
}
const OrgUnitListItemToAddContainer = connect()(OrgUnitListItemToAddPresentation);

export default OrgUnitHierarchy;



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitHierarchy.js